module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("My thanks to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("People")]), _vm._v(" Managing Editor Landon Y. Jones, my editors, Roger Wolmuth, Joe Treen and Jack Friedman, and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("People")]), _vm._v(" correspondents Don Sider and Gail Wescott. I also want to express my sincere gratitude to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("People")]), _vm._v(" Senior Writer Cynthia Sanz for editing this book and for all of her support.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcc4654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0